import { Component, OnInit, EventEmitter, Output, HostListener } from '@angular/core';
import { ApiCallerService } from '../services/api-caller.service';
import {AngularFireDatabase} from 'angularfire2/database';
import * as firebase from 'firebase/app'
export class SessionInfo {
  status: number;
  id: number;
  pass: string;
}

@Component({
  selector: 'app-student-view',
  templateUrl: './student-view.component.html',
  styleUrls: ['./student-view.component.css']
})
export class StudentViewComponent implements OnInit {

@Output() startStudentQuiz = new EventEmitter();

sessions: any[];
info : SessionInfo;

title = "VÄLKOMMEN ELEV!";
description = "Du ska få en kod av din lärare för att koppla upp dig till lektionen.";

code = "";
codeAccepted = false;


@HostListener('window:beforeunload', [ '$event' ])
beforeUnloadHander(event) {
  this.db.list('/Session-'+this.service.sessionId + "/disconnected").push("1");
}

checkCode() {
    
  if(this.code == "")
  {
    return;
  }

  for(let row of this.sessions){
      if (this.code == row){
        this.service.myAnswers = [];
        this.service.sessionId = this.code;
        this.codeAccepted = true;
        this.title = "DU ÄR NU ANSLUTEN TILL LEKTIONEN!";
        this.description = "Håll det här fönstret i webbläsaren öppet. På den här sidan kommer du snart att få börja jobba. Din lärare styr vilken del av lektionen som ska synas här. Så håll ut, snart börjar det :)";      
        this.db.list('/Session-'+ this.code + "/connected").push("student");
        this.service.currentQuestion = 1;

        // Lyssnar efter att läraren aktiverar ett spår, startar läraren ett spår så startar quiz-vyn för eleven
        this.db.list('/Session-'+ this.code + "/action").valueChanges().subscribe((value: any) => {

            if (value.length == 0) {
              return;
            }
          // if (value == "activate") {
            this.startStudentQuiz.emit();
          // }

        });
        firebase.analytics().logEvent("Student joined session");
        
      }
  }

}

OnInput(event){
	this.code = event.target.value; 
}


  constructor(
    private service: ApiCallerService,
    private db: AngularFireDatabase) { }

  ngOnInit() {

    
    this.db.list('/Sessions').valueChanges().subscribe((value: any) => {
      this.sessions = value;
    });





  }

}
